import { render, staticRenderFns } from "./transfer-panel.vue?vue&type=template&id=10ac2c27&scoped=true&"
import script from "./transfer-panel.vue?vue&type=script&lang=js&"
export * from "./transfer-panel.vue?vue&type=script&lang=js&"
import style0 from "./transfer-panel.vue?vue&type=style&index=0&id=10ac2c27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac2c27",
  null
  
)

export default component.exports